import React from 'react';

export default function ChatBotInsufficientPermissionsPopover() {
    return (
        <div className="flex flex-col gap-2 absolute top-[40px] right-[0px] w-[392px] h-fit bg-black shadow-sf-small border border-sf-gray-800 z-40 rounded-xl p-4">
            <p className="text-left whitespace-pre-line leading-relaxed text-white font-medium text-13">
                Insufficient Permissions
            </p>
            <p className="text-left whitespace-pre-line leading-relaxed text-white font-normal text-12">
                Silverfort AI Filter utilizes the Azure OpenAI Service on Silverfort meta-data. Therefore, usage of the
                Silverfort AI Filter may be subject to Microsoft's terms.
                {'\n'}
                You do not have sufficient permissions to enable this feature. Contact a user with permissions to edit
                Silverfort Settings to allow Azure OpenAI usage.
            </p>
        </div>
    );
}
